import axios from "axios";
import { baseurl } from "../config/baseUrl";

// const baseurl = "https://36g77kr5-5127.inc1.devtunnels.ms/";
// const baseurl =  "https://testapi.kickrtechnology.in/backend"
const api = axios.create({
  baseURL: baseurl,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
